import { useRouter } from "vue-router";
import { useStore } from 'vuex';
import { createPageVisitLog } from "@/services/PageVisitLog";


export function pageVisitLogger(){
    const router = useRouter()
    const store = useStore()

    const logLink = (toPage) => {
        const store = useStore()

        let previousTitle = document.title

        const token = store.state.auth.token
        if(token) {
            let data = JSON.stringify({
            from_page_name: previousTitle, 
            to_page_name: toPage
            })
            createPageVisitLog(token, data)
        }
    }

    const navigateToPage = (route, pageName) => {
        const selectedPageConfigName = store.getters['pageConfigs/showSelectedPageConfigName']
        if(pageName === 'Companies'){
            logLink(selectedPageConfigName)
        } else {
            router.push(route)
            logLink(pageName)
        }
    }

    return {
        navigateToPage,
        logLink,
    }




}
